<template>
    <div>
        <!-- 航空动力 -->
        <div class="title" ref="title">
            <transition name="text" appear>
                <div class="textArea">
                    关于我们
                </div>
            </transition>
        </div>
        <div class="introduce" ref="introduce">
            <div class="left">
                <img :src="require('@/assets/about/logo.png')" style="width: 35vw;margin-top: 40vh;">
                <!-- <img :src="require('@/assets/about/pic_2.png')" style="width: 28vw;"> -->
            </div>
            <div class="right">
                <transition name="aboutTitle" appear v-if="introduceTextShow">
                    <div class="introduceTitle">关于我们</div>
                </transition>

                <el-divider></el-divider>
                <transition name="aboutText" appear v-if="introduceTextShow">
                    <div class="introduceText">
                        清航空天（北京）科技有限公司成立于2019年4月，是清华大学航天航空学院的新型成果转化机构。作为国内领先的增压燃烧技术商业公司，清航空天深耕动力与能源领域多年，立志成为先进燃烧技术领跑者。
                    </div>
                </transition>

            </div>
        </div>
        <div class="certification" ref="certification">
            <div class="certificationTitle">荣誉资质</div>
            <el-divider></el-divider>
            <!-- <div class="certificationPic">
                <div class="picLeft">
                    <div v-for="pic in leftList" class="picArea">
                        <el-image class="pic" :src="pic.url" :preview-src-list="leftUrlList"></el-image>
                        <div class="text">{{ pic.text }}</div>
                    </div>

                </div>
                <div class="picRight">
                    <div v-for="pic in rightPicList" class="picArea">
                        <el-image class="pic" :src="pic.url" :preview-src-list="rightUrlList"></el-image>
                        <div class="text">{{ pic.text }}</div>
                    </div>
                </div>
            </div> -->
            <div class="certificationPic1">
                <div class="up">
                    <div v-for="pic in leftList" class="picArea">
                        <el-image class="pic" :src="pic.url" :preview-src-list="leftUrlList"></el-image>
                        <div class="text">{{ pic.text }}</div>
                    </div>
                </div>
                <div class="down">
                    <div v-for="pic in rightPicList" class="picArea">
                        <el-image class="pic" :src="pic.url" :preview-src-list="rightUrlList"></el-image>
                        <div class="text">{{ pic.text }}</div>
                    </div>
                </div> 
            </div>
        </div>

    </div>

</template>

<script>
export default {
    data() {
        return {
            id: 'title',
            distance: 0,
            introduceTextShow: false,
            leftList: [
                {
                    url: require('@/assets/about/11.jpg'),
                    text: '博士后科研工作站'
                },
                {
                    url: require('@/assets/about/4.jpg'),
                    text: '专精特新中小企业证书'
                },
                {
                    url: require('@/assets/about/2.jpg'),
                    text: '中关村高新技术企业证书'
                }, {
                    url: require('@/assets/about/3.jpg'),
                    text: '高新技术企业证书'
                }, {
                    url: require('@/assets/about/5.jpg'),
                    text: '北京市新技术新产品证书'
                },
                {
                    url: require('@/assets/about/1.jpg'),
                    text: '2020年-中国发明创业奖·创新奖'
                }, {
                    url: require('@/assets/about/6.png'),
                    text: '科创中国榜单'
                }, {
                    url: require('@/assets/about/10.jpg'),
                    text: '知识产权优势单位证书'
                }, {
                    url: require('@/assets/about/14.jpg'),
                    text: '中国创业创新大赛-创业创新50强'
                }, {
                    url: require('@/assets/about/15.jpg'),
                    text: '首都劳动奖状'
                },
            ],
            leftUrlList: [
                require('@/assets/about/1.jpg'),
                require('@/assets/about/2.jpg'),
                require('@/assets/about/3.jpg'),
                require('@/assets/about/4.jpg'),
                require('@/assets/about/5.jpg'),
                require('@/assets/about/6.png'),
                require('@/assets/about/10.jpg'),
                require('@/assets/about/11.jpg'),
                require('@/assets/about/14.jpg'),
                require('@/assets/about/15.jpg'),
                

            ],
            rightPicList: [
                {
                    url: require('@/assets/about/7.jpg'),
                    text: '2021年-发明协会奖-发明创业奖创新奖'
                },
                {
                    url: require('@/assets/about/8.jpg'),
                    text: '质量管理体系证书'
                },
                {
                    url: require('@/assets/about/9.jpg'),
                    text: '安全生产标准化三级'
                }, {
                    url: require('@/assets/about/12.png'),
                    text: '北京市工人先锋号'
                },{
                    url: require('@/assets/about/13.jpg'),
                    text: '中国创业创新大赛-优秀企业'
                },
            ],
            rightUrlList: [
                require('@/assets/about/7.jpg'),
                require('@/assets/about/8.jpg'),
                require('@/assets/about/9.jpg'),
                require('@/assets/about/12.png'),
                require('@/assets/about/13.jpg')
            ],
        }
    },
    mounted() {
        this.scrollToDistance()
        setTimeout(() => {
            window.addEventListener('scroll', this.handleScroll);
        }, 500);
    },
    methods: {
        handleScroll() {
            if (this.introduceTextShow === false) {
                if (this.$refs.introduce) {
                    this.introduceTextShow = document.documentElement.scrollTop > this.$refs.introduce.getBoundingClientRect().top;
                }
            }
        },
        scrollToDistance() {
            this.id = this.$route.query.id
            if (this.$refs[this.id]) {
                this.distance = this.$refs[this.id].getBoundingClientRect().top + window.scrollY;
            }
            if (this.id === 'introduce') {
                this.introduceTextShow = true
            }
            window.scrollTo({
                top: this.distance,
                behavior: 'smooth'
            });
        },
    },
    watch: {
        '$route.params': {
            handler() {
                this.scrollToDistance()
            }
        }
    },


}
</script>

<style lang="scss" scoped>
.title {
    height: 100vh;
    width: 100%;
    background-image: url('../../assets/about/页面4-1.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;


    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    .textArea {
        height: 20%;
        width: 100%;
        background-color: rgb(76, 76, 226, 0.5);
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        font-family: QHKT;
        font-weight: bold;
        font-size: 50px;
        color: white;
    }
}

.introduce {
    width: 100%;
    height: 100vh;
    background-color: rgba(14, 14, 15, 0.84);
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    font-family: QHKT;
    color: white;

    .left {
        width: 35%;

    }

    .right {
        width: 55%;
        height: 60vh;
        margin-top: 14vh;
        font-size: 40px;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;

        .el-divider {
            background-color: rgba(187, 187, 187, 1);
            width: 72%;
            border: 1px solid rgba(187, 187, 187, 1);
        }

        .introduceText {
            width: 72%;
            text-align: justify;
            // margin-left: 15%;
            text-indent: 2em;
        }
    }
}

.certification {
    width: 100%;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.84);
    font-family: QHKT;
    color: white;
    font-weight: bold;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;

    .certificationTitle {
        font-size: 50px;
        text-align: center;
        height: 10%;
        margin-top: 5vh;
    }

    .el-divider {
        width: 86%;
        border: 1px solid rgba(187, 187, 187, 1);
        margin-left: 8.5%;
    }

    .certificationPic {
        height: 80%;
        display: flex;
        flex-direction: row;
        justify-content: center;



        .picLeft {
            width: 40%;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-evenly;

            .picArea {
                width: 13vw;
                height: 18vh;
                margin-left: 1vw;
                position: relative;

                .pic {
                    height: 100%;
                    // width: 100%;
                }

                .pic:hover {
                    // border: 5px solid black;
                    transform: scale(0.95)
                }

                .text {
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    text-align: center;
                    color: white;
                    width: 100%;
                    height: 45px;
                    background-color: rgba(65, 41, 95, 0.5);
                }
            }

        }

        .picRight {
            width: 50%;
            display: flex;
            flex-wrap: wrap;
            align-content: center;
            justify-content: center;

            .picArea {
                width: 11vw;
                height: 31.3vh;
                margin-left: 1vw;
                position: relative;

                .pic:hover {
                    transform: scale(0.95)
                    // border: 5px solid black;
                }

                .text {
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    text-align: center;
                    color: white;
                    width: 100%;
                    height: 45px;
                    background-color: rgba(65, 41, 95, 0.5);
                }
            }
        }
    }

    .certificationPic1{
        height: 80%;
        display: flex;
        flex-direction: column;

        .up{
            height: 52%;
            width: 90%;
            margin-left: 5%;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-evenly;
            .picArea {
                width: 18%;
                height: 18vh;
                margin-left: 1vw;
                position: relative;

                .pic {
                    width: 13vw;
                    height: 100%;
                    // margin-left: 2vw;
                }

                .pic:hover {
                    // border: 5px solid black;
                    transform: scale(0.95)
                }

                .text {
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    text-align: center;
                    color: white;
                    width: 13vw;
                    height: 45px;
                    background-color: rgba(65, 41, 95, 0.5);
                }
            }
        }

        .down{
            height: 44%;
            width: 90%;
            margin-left: 5%;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-evenly;
            .picArea {
                width: 18%;
                height: 31.3vh;
                margin-left: 1vw;
                position: relative;

                .pic{
                    width: 13vw;
                }

                .pic:hover {
                    
                    transform: scale(0.95)
                    // border: 5px solid black;
                }

                .text {
                    position: absolute;
                    top:32.5vh;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    text-align: center;
                    color: white;
                    width: 13vw;
                    height: 45px;
                    background-color: rgba(65, 41, 95, 0.5);
                }
            }
        }
    }
}


// .text-enter-active {
//     animation: bounce-in 2s;
// }

// .text-enter {
//     opacity: 0;
// }

// @keyframes bounce-in {
//     0% {
//         transform: scale(0);
//     }

//     100% {
//         transform: scale(1);
//     }
// }

.text-enter-active {
    transition: all 2s;
}

.text-enter {
    opacity: 0;
    transform: translateY(-50px);
}

.aboutTitle-enter-active {
    transition: all 3s;
}

.aboutTitle-enter {
    opacity: 0;
    transform: translateX(-400px);
}

.aboutText-enter-active {
    transition: all 3s;
}

.aboutText-enter {
    opacity: 0;
    transform: translateX(400px);
}
</style>